import React, {Component} from 'react';
import PropTypes from 'prop-types';
import EnvironmentBanner from './EnvironmentBanner';


export class AppTopbar extends Component {
    constructor() {
        super();
        this.state = {
            noticeCount: 0
        };
    }

    componentDidMount = () => {


    }

    render() {
        return (
            <div className="app-admin-topbar-wrap">
                <EnvironmentBanner />
                <div className="layout-topbar app-admin-topbar clearfix">
                    <a className="layout-menu-button" onClick={this.props.onToggleMenu} aria-label="Toggle menu">
                        <span className="pi pi-bars"/>
                    </a>

                    <div className="app-admin-topbar__actions">
                        <a
                            className="app-admin-topbar__btn"
                            title="Back"
                            aria-label="Back"
                            onClick={() => {
                                const location = window.location.toString();
                                if (!location.endsWith('#/')) {
                                    if (location.indexOf("merchantAccountSave") >= 0 || location.indexOf("merchantBranchSave") >= 0) {
                                        window.history.go(-2);
                                    } else {
                                        window.history.go(-1);
                                    }
                                }
                            }}>
                            <span className="layout-topbar-icon pi pi-angle-left"/>
                        </a>
                        <a
                            className="app-admin-topbar__btn"
                            title="Home"
                            aria-label="Home"
                            onClick={() => {
                                window.location = '#/';
                            }}>
                            <span className="layout-topbar-icon pi pi-home"/>
                        </a>
                        <a
                            className="app-admin-topbar__btn"
                            title="Log out"
                            aria-label="Log out"
                            onClick={this.props.logout}>
                            <span className="layout-topbar-icon pi pi-power-off"/>
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

AppTopbar.propTypes = {
    onToggleMenu: PropTypes.func.isRequired,
    logout: PropTypes.func
};

AppTopbar.defaultProps = {
    onToggleMenu: null
};
